import React, { Component, type JSX } from 'react';
import PropTypes from 'prop-types';
import { SearchBoosterResultsBookBtn } from './SearchBoosterResultsBookBtn';
import { Examentraining, TrainingSearchResult } from '../../models/Examentraining';

const monthLabelShort = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

interface ComponentProps {
  training: TrainingSearchResult;
  type: 'distance' | 'datum_start';
}

export class SearchBoosterResultsTrainingRow extends Component<ComponentProps> {
  public render(): JSX.Element {
    const { training, type } = this.props;

    // count date from UTC time in case people visit the lyceo website from other parts of the world
    let timezone = 'T00:00:00Z';
    let startDate = new Date(training.datum_start + timezone);
    let endDate = new Date(training.datum_eind + timezone);
    const days = training.training_dates.split(',').length;

    // set date labels (21 - 23 jan) or (31 jan - 2 feb)
    let beginMaand = monthLabelShort[startDate.getUTCMonth()];
    let eindMaand = monthLabelShort[endDate.getUTCMonth()];
    let begin = `${startDate.getUTCDate()} ${beginMaand !== eindMaand ? beginMaand : ''}`;
    let eind = `${endDate.getUTCDate()} ${eindMaand}`;

    // check if the training is almost full
    const capacity = parseInt(training.beschikbare_capaciteit, 10);
    const urgent = capacity <= 3;
    const superurgent = capacity <= 1;
    let rowClass = 'search-results__item-table-row';
    if (urgent === true) {
      rowClass += ' search-results__item-table-row--urgent';
    }

    return (
      <div className={rowClass} data-id={training.id_training}>
        <div className='search-results__item-table-cell search-results__item-table-cell--body'>
          <span className="search-results__item-label">{training.product_naam}</span>
          <strong>
            <span className="search-results__item-prop">
              {begin} {days === 2 ? 'en' : 't/m'} {eind}
              {type !== 'distance' && ` - ${training.vak_naam} ${training.vak_niveau}`}
              &nbsp;|&nbsp;
            </span>
            <span className="search-results__item-prop">
              {days} dagen &nbsp;|&nbsp;
            </span>
            <span className="search-results__item-prop">
              {training.general_start_time} - {training.general_end_time}
              {superurgent === true ? <SuperUrgencyNotification/> : urgent === true ? <UrgencyNotification/> : ''}
            </span>
          </strong><br/>
          {type === 'distance'
            ? `${training.vak_naam} ${training.vak_niveau}`
            : `${training.loc_stad}, ${training.loc_straat} ${training.loc_nr}`}
          <br/>
        </div>
        <div className="search-results__item-table-buttons">
          <div className='search-results__item-table-cell search-results__item-table-cell--price'>
            € {training.prijs.replace('.', ',')}
          </div>
          <SearchBoosterResultsBookBtn training={training}
                                       noBooking={training.order_type === 'contact'}
                                       preregister={training.order_type === 'preregister'}/>
        </div>
      </div>);
  }
}

export const UrgencyNotification = (): JSX.Element => {
  return (
    <span className="search-results__item-urgent-note">
      <span className="search-results__item-urgent-note-text">
        Nog maar enkele plaatsen!
      </span>
      <i className="fa fa-info-circle bem-info-icon">
        <span className="js-tooltip bem-tooltip bem-tooltip--no-wrap animated fadeInUp">
          Boek snel, deze training is bijna vol.
        </span>
      </i>
    </span>
  );
};


export const SuperUrgencyNotification = (): JSX.Element => {
  return (
    <span className="search-results__item-urgent-note">
      <span className="search-results__item-urgent-note-text">
        Nog maar 1 plek!
      </span>
      <i className="fa fa-info-circle bem-info-icon">
        <span className="js-tooltip bem-tooltip bem-tooltip--no-wrap animated fadeInUp">
          Er is nog maar 1 plek, bel ons om te boeken.
        </span>
      </i>
    </span>
  );
};
